const my_profile = {
  viewMyClubSeacretProfile: "Voir mon profil ClubSeacret", // translated
  unverifiedEmail: "E-mail non vérifié", // translated
  viewMoreDetails: "Afficher plus de détails", // translated
  verifiedEmail: "E-mail vérifié", // translated
};

export default my_profile;
